/* global axios */
import ApiClient from '../ApiClient';

class AiAgentDeploys extends ApiClient {
  constructor() {
    super('ai_agents/brains', { accountScoped: true });
  }

  get({ brainId }) {
    return axios.get(`${this.url}/${brainId}/deploys`);
  }

  create({ brainId, deploy }) {
    return axios.post(`${this.url}/${brainId}/deploys`, { deploy });
  }

  update({ brainId, id, deploy }) {
    return axios.patch(`${this.url}/${brainId}/deploys/${id}`, { deploy });
  }
}

export default new AiAgentDeploys();
